import { CardBrand } from "./PayClasses";

const bindChange = (setVal: (val: any, ...args: any)=>void, semantic: boolean=false)=>{
	return (e: { target: { value: string } } | any, data?: { value?: any, checked?: any })=>{
		if(semantic){
			return setVal(data.checked || data.value || null);
		}else{
			return setVal(e.target.value);
		}
	}
}

const bindFormChange = <T>(val: T, setVal: (val: any, ...args: any)=>void, setDirty?: (val: boolean)=>void)=>{
	return (name: keyof T, semantic: boolean=false, target: boolean=false)=>{
		return (e: { target: { value: string } } | any, data?: { value?: any, checked: boolean } | any)=>{
			if(semantic){
				setVal({ ...val, [name]: typeof data.checked!=='undefined' ? data.checked : data.value });
			}else if(target){
				setVal({ ...val, [name]: e.target.value })
			}else{
				setVal({ ...val, [name]: e });
			}
			if(setDirty) setDirty(true);
		}
	}
}

function isJWT(token: string){
	return (/(^[A-Za-z0-9-_]*\.[A-Za-z0-9-_]*\.[A-Za-z0-9-_]*$)/gi).test(token);
}

function addCommas(num: number, fixed: boolean=true, hideZero: boolean=false){
	if (!num && num !== 0) return 'ERR';
	var c = num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	var dec = c.substring(c.length-2, c.length);
	return fixed ? (hideZero && dec == '00' ? c.slice(0, -3) : c) : c.slice(0, -3);
}

function formatCreditCard(val: string){
	if(!val) return '';
	val = val.replace(/\ /g, '');
	var final_val = '';
	for(var i=0; i<val.length; i++){
		final_val += val[i];
		if(((i+1)%4)==0 && i<(val.length-1)){
			final_val += ' '
		}
	}
	return final_val;
}

function formatExpiration(val: string){
	val = val.replace(/\//g, '');
	if(val.length>=3){
		return val.replace(/\//g, '').substring(0, 2) + '/' + val.substring(2);
	}
	return val.replace(/\//g, '');
}

function getCardBrandName(brand: CardBrand){
	if(!brand) return null;
	switch(brand){
		case CardBrand.VISA: return 'Visa';
		case CardBrand.MASTERCARD: return 'MasterCard';
		case CardBrand.AMERICAN_EXPRESS: return 'AMEX';
		default: return null;
	}
}

export {
	addCommas,
	bindChange,
	bindFormChange,
	formatCreditCard,
	formatExpiration,
	getCardBrandName,
	isJWT,
}